// shell-sdk/src/event-bus.js

const EVENT_NAME = "shell:event";

export function publishLocalEvent(event, payload) {
    window.dispatchEvent(
        new CustomEvent(EVENT_NAME, { detail: { event, payload } })
    );
}

export function subscribeLocalEvent(event, cb) {
    const handler = (e) => {
        if (e.detail?.event === event) {
            cb(e.detail.payload);
        }
    };

    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
}
